import { Collapse, Container } from "@mui/material";
import ContainedTabs, { ContainedTabsProps } from "components/Tabs/Tabs3";
import useScroll from "helpers/useScroll";
import { CSSProperties, ReactNode, useRef, useState } from "react";
import BasicButton from "components/BasicInputs/BasicButton";
import ChevronIcon from "assets/icons/ChevronIcon";

export interface SeeMoreProps {
  tabs?: ContainedTabsProps["tabs"];
  contents?: ReactNode[];
  collapseLabel?: string;
  expandLabel?: string;
  style?: CSSProperties;
  btnStyle?: CSSProperties;
  iconStyle?: CSSProperties;
  iconColor?: string;
  scrollable?: boolean;
}

export function SeeMore(props: SeeMoreProps) {
  const { contents, tabs, collapseLabel, expandLabel, style } = props;
  const [active, setActive] = useState(0);
  const [appear, setAppear] = useState(false);
  const ref = useRef(null);
  const { scrollTo } = useScroll();

  const btnLabel = appear ? collapseLabel || "بستن" : expandLabel || "مشاهده اطلاعات بیشتر";

  return (
    <Container ref={ref} maxWidth="xl" style={{ paddingBottom: 24, ...style }}>
      <Collapse
        in={appear}
        addEndListener={() => {
          ref.current && props.scrollable && scrollTo(ref.current);
        }}
      >
        {tabs && (
          <div
            style={{
              display: "flex",
              padding: "10px 24px",
              border: "1px solid #DCDFE8",
              borderRadius: "6px 6px 0px 0px",
            }}
          >
            <ContainedTabs tabs={tabs} onChange={(val) => val !== undefined && setActive(val)} />
          </div>
        )}
        <div>{contents && contents[active]}</div>
      </Collapse>
      <BasicButton onClick={() => setAppear((x) => !x)} style={{ marginTop: 24, color: "#515151" }}>
        <span>{btnLabel}</span>
        <span
          style={{
            width: 24,
            height: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#EBEFF5",
            borderRadius: 3,
          }}
        >
          <ChevronIcon rotate={appear ? "top" : undefined} color="#95A3B5" />
        </span>
      </BasicButton>
    </Container>
  );
}
